// Vendor Libs
import React from 'react';

// Components
import NetworkForm from './network-form';
import Permissions from '../core/permissions';

// Containers
import FormData from '../../containers/form-data';

const formName = 'createNetwork';

function CreateNetwork() {
    return (
        <Permissions
            accessRequirement="create"
            elementService="network"
            notAuthorizedMessage={true}
            requiresServiceAccess={true}
        >
            <FormData formName={formName}>
                {({resetForm}) => (
                    <NetworkForm className="create-network" editing={false} formName={formName} onReset={resetForm} />
                )}
            </FormData>
        </Permissions>
    );
}

export default CreateNetwork;
